<template>
   <div class="">
        <component v-bind:is="component"></component>
    </div>
</template>
<script>
export default {
    components: {
    },
    name: 'PcAddVoucher',
    props: {
    },
    data () {
        return {
        };
    },
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    computed: {
        component () {
            let _type = this.$route.query.type;
            return () => import(`./Add/Temp_` + _type + `.vue`);
        },
    },
    watch: {
    },
    methods: {
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/Add.vue